import { render, staticRenderFns } from "./ContactLink.vue?vue&type=template&id=78939064&scoped=true"
import script from "./ContactLink.vue?vue&type=script&lang=js"
export * from "./ContactLink.vue?vue&type=script&lang=js"
import style0 from "./ContactLink.vue?vue&type=style&index=0&id=78939064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78939064",
  null
  
)

export default component.exports